import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import { OneSitePropertyConfiguration } from '../../../../../api/PropertyIntegration';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: OneSitePropertyConfiguration;
    update: (newConfig?: OneSitePropertyConfiguration) => void;
}

const OneSiteConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="OneSite Configuration"
        cardOpen={!!props.config}
        onCardOpenChange={open => {
            if (isUser)  return;
            props.update(open ? { pmcId: '', siteId: '', unitDescription: '' } : undefined)}}
    >
        {props.config ? (
            <div>
                <FormInput
                    labelProps={{
                        labelText: 'PMC ID',
                        invalidText: 'Please enter a valid numeric OneSite PMC ID'
                    }}
                    inputProps={{
                        id: 'pmc-id',
                        name: 'pmcId',
                        value: props.config.pmcId,
                        type: 'string',
                        required: true,
                        pattern: '^[0-9]+$',
                        disabled: isUser
                    }}
                    onChange={(_name, value) =>
                        !isUser && props.update({
                            ...props.config!,
                            pmcId: value.toString()
                        })
                    }
                />
                <FormInput
                    labelProps={{
                        labelText: 'Site ID',
                        invalidText: 'Please enter a valid numeric OneSite Site ID'
                    }}
                    inputProps={{
                        id: 'site-id',
                        name: 'siteId',
                        value: props.config.siteId,
                        type: 'string',
                        required: true,
                        pattern: '^[0-9]+$',
                        disabled: isUser
                    }}
                    onChange={(_name, value) =>
                        !isUser && props.update({
                            ...props.config!,
                            siteId: value.toString()
                        })
                    }
                />
                <FormInput
                    labelProps={{
                        labelText: 'Unit Description'
                    }}
                    inputProps={{
                        id: 'unit-description',
                        name: 'unitDescription',
                        value: props.config.unitDescription,
                        type: 'string',
                        required: false,
                        disabled: isUser
                    }}
                    onChange={(_name, value) =>
                        !isUser && props.update({
                            ...props.config!,
                            unitDescription: value.toString()
                        })
                    }
                    helpTextProps={{
                        helpText: 'This description will be included in the comments ' +
                        'section of the OneSite activity'
                    }}
                />
            </div>
        ) : (
            <div />
        )}
    </CollapsibleCard>
);
};
export default OneSiteConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/OneSiteConfigurationSection.tsx